module.exports = __webpack_public_path__ + "static/media/BrandTag.a050f215.svg";